import React from 'lib/react';
import {
  EVBox,
  EVCheckbox,
  EVInputLabel,
  EVTypography,
  makeStyles,
} from 'lib/components';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    '& .myev-MuiCheckbox-colorPrimary.Mui-checked': {
      color: theme.evPalette.ocean[600],
    },
  },
  checkboxLabel: {
    fontSize: '14px',
    color: theme.evPalette.charcoal[900],
    fontFamily: theme.typography.fontFamily,
  },
  labelClass: {
    display: 'flex',
    alignItems: 'center',
  },
}));

/**
 * Checkbox component with a Checkbox and label
 */
function LabelledCheckbox(props) {
  const styles = useStyles();
  const {
    checkboxId, disabled, checked, handleCheckboxSelectChange, checkboxValue, checkboxLabel, checkBoxName, inputRef, alignLabelCenter, ...rest
  } = props;

  return (
    <EVBox className={styles.checkboxContainer}>
      <EVCheckbox
        id={checkboxId}
        name={checkBoxName}
        disabled={disabled}
        checked={checked}
        onChange={handleCheckboxSelectChange}
        value={checkboxValue}
        color="primary"
        inputRef={inputRef}
        {...rest}
      />
      { checkboxLabel && (
        <EVInputLabel className={alignLabelCenter && styles.labelClass} htmlFor={checkboxId}>
          <EVTypography
            className={styles.checkboxLabel}
          >
            {checkboxLabel}
          </EVTypography>
        </EVInputLabel>
      ) }
    </EVBox>
  );
}

LabelledCheckbox.defaultProps = {
  /**
   * @property {String} checkboxLabel - Label given to a checkbox
   */
  checkboxId: '',
  checkboxLabel: '',
  disabled: false,
  checkBoxName: '',
};

LabelledCheckbox.propTypes = {
  checkboxId: PropTypes.string,
  checkBoxName: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool.isRequired,
  handleCheckboxSelectChange: PropTypes.func.isRequired,
  checkboxValue: PropTypes.bool.isRequired,
  checkboxLabel: PropTypes.node, // #genai
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  alignLabelCenter: PropTypes.bool,
};

LabelledCheckbox.defaultProps = {
  inputRef: null,
  alignLabelCenter: false,
};

export default LabelledCheckbox;
